module.exports = __webpack_public_path__ + "static/media/aquarius-lemon.97cff356.jpg";